<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import uploadfile from "../../../common/uploadFile/index.vue";
import {
  templateInfopage,
  deleteTemplate,
  getTemplate,
  getFileColumn,
  templateInfoSave,
  getTemplateById,
  templateinfoupdate,
} from "../../../../api/home.js";
export default {
  name: "CustomTemplate",
  components: {
    uploadfile,
  },
  data: function () {
    return {
      tablekey: 0,
      upformdata: {},
      headData: getdata().headData,
      tableData: [],
      columnNameOptions: [],
      headDatamb: getdata().headDatamb,
      tableDatamb: [],
      filediag: false,
      updatediag: false,
      pagination: getdata().pagination,
      sort: "",
      order: "",
      upform: {
        name: "",
        titleRow: 0,
        purpose: "",
        valueRow: 0,
        batchNum: "",
        columnNames: "",
        exclusionColumn: "",
      },
      czstate: "",
      templatePurpose :[],
      filterPurposeData:[],
      purposeData :[]
    };
  },
  mounted() {},
  created() {
    this.templateInfopage();   
    this.purposeData = this.$mbytlist 
  },
  methods: {
    forupdate(row) {
      this.purposeData = this.$mbytlist;
      getTemplateById({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 1) {
          if (this.$notemptyandnull(res.data.data.columnNames)) {
            this.columnNameOptions = res.data.data.columnNames.split(",");
          }
          this.upform.batchNum = res.data.data.batchNum;
          this.upform.columnNames = res.data.data.columnNames;
          this.upform.valueRow = res.data.data.valueRow;
          this.upform.titleRow = res.data.data.titleRow;
          this.upform.name = res.data.data.name;
          this.upform.id = res.data.data.id;
          this.upform.purpose = res.data.data.purpose;
          var json = JSON.parse(res.data.data.templateJson);
          this.upform.exclusionColumn = json.exclusionColumn;
          this.tableDatamb = json.template;
          this.czstate = "update";
          this.updatediag = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    forsubmitall() {
      if (this.$emptyandnull(this.upform.purpose)) {
        this.$message.error("模板用途不能为空");
        return false;
      }
      if (this.$emptyandnull(this.tableDatamb)) {
        this.$message.error("模板数据不能为空");
        return false;
      }
      if (this.$emptyandnull(this.upform.titleRow)) {
        this.upform.titleRow = 0;
      }
      if (this.$emptyandnull(this.upform.valueRow)) {
        this.upform.valueRow = 0;
      }
      let params = JSON.parse(JSON.stringify(this.upform));
      let templateJson = {
        template: this.tableDatamb,
        exclusionColumn: this.upform.exclusionColumn,
      };
      params.templateJson = JSON.stringify(templateJson);
      if (this.czstate == "create") {
        templateInfoSave(params).then((res) => {
          if (res.data.code == 1) {
            this.updatediag = false;
            this.templateInfopage();
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        templateinfoupdate(params).then((res) => {
          if (res.data.code == 1) {
            this.updatediag = false;
            this.templateInfopage();
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    forupload() {
      if (this.$emptyandnull(this.upform.purpose)) {
        this.$message.error("模板用途不能为空");
        return false;
      }
      if (this.$emptyandnull(this.upform.titleRow)) {
        this.upform.titleRow = 0;
      }
      if (this.$emptyandnull(this.upform.valueRow)) {
        this.upform.valueRow = 0;
      }
      this.filediag = true;
    },
    getuploadparams(e) {
      this.upformdata = e;
    },
    submitupload() {
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }
      let formData = {
        name: this.upform.name,
        titleRow: this.upform.titleRow,
        purpose: this.upform.purpose,
        valueRow: this.upform.valueRow,
        file: this.upformdata.upfile,
      };
      getFileColumn(formData).then((res) => {
        if (res.data.code == 1) {
          if (this.$notemptyandnull(res.data.data.columnNames)) {
            this.columnNameOptions = res.data.data.columnNames.split(",");
            this.upform.batchNum = res.data.data.batchNum;
            this.upform.columnNames = res.data.data.columnNames;
            this.upform.fileUrl = res.data.data.fileUrl;
            this.upform.fileName = res.data.data.fileName;
            this.filediag = false;
            this.getTemplate();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    forcreateTable() {
      this.czstate = "create";
      let purposeArr = JSON.parse(JSON.stringify(this.$mbytlist));
      purposeArr.map((item,index)=>{
        if(this.filterPurposeData.indexOf(item.value) === 0)
          purposeArr.splice(index,1);
      });
      this.purposeData = purposeArr;
      this.updatediag = true;
    },
    getTemplate() {
      getTemplate({
        purpose: this.upform.purpose,
      }).then((res) => {
        var json = JSON.parse(res.data.data.templateJson);
        this.upform.exclusionColumn = json.exclusionColumn;
        this.tableDatamb = json.template;
      });
    },
    fordelete() {
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseitem)) {
        this.$message.error("请选择数据");
        return false;
      }
      this.$showConfirm({
        message: "确认删除?",
      }).then((res) => {
        if (res == "confirm") {
          deleteTemplate({
            ids: chooseitem.map((item) => item.id).join(","),
          }).then((res) => {
            if (res.data.code == 1) {
              this.$message.success("删除成功");
              this.pagination.paginationkey++;
              this.pagination.pageNum = "1";
              this.templateInfopage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.templateInfopage();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.templateInfopage();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.templateInfopage();
    },
    templateInfopage() {
      let params = {};
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = this.sort;
      params.order = this.order;
      templateInfopage(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
        res.data.data.records.forEach(item => {
           this.filterPurposeData.push(item.purpose);
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
